// import { vertexShader, fragmentShader } from './shader'
// import Tween from './tween'
import * as THREE from "../../../../../libs/three.js/build/three.module.js";

const DEG2RAD = Math.PI / 180

class Particle {
  
  constructor() {
    
    this.position = new THREE.Vector3()
    this.velocity = new THREE.Vector3()
     
    
    this.angle = 0
    this.angleVelocity = 0
    this.angleAcceleration = 0
    this.size = 16
    this.color = new THREE.Color()
    this.opacity = 1

    this.rebornCount = 0//重生次数
    this.age = 0
    this.alive = 0 //注意，一开始时是未出生的
    this.deadAge = 0//已死亡时间
    this.sizeTween = null
    this.colorTween = null
    this.opacityTween = null
  }

  update(dt) { 
    //s = s0 + (v0 + at) * t 或 lastS + delta(vt)
    
    this.position.add(this.velocity.clone().multiplyScalar(dt))
    this.velocity.multiplyScalar( 1+this.acceleration*dt )
    
    this.angle += this.angleVelocity * DEG2RAD * dt
    this.angleVelocity += this.angleAcceleration * DEG2RAD * dt
    this.age += dt

    if(this.sizeTween.times.length > 0) {
      this.size = this.sizeTween.lerp(this.age/this.deathAge)
    }

    if(this.colorTween.times.length > 0) {
      const colorHSL = this.colorTween.lerp(this.age/this.deathAge)
      this.color = new THREE.Color().setHSL(colorHSL.x, colorHSL.y, colorHSL.z)
    }

    if(this.opacityTween.times.length > 0) {
      this.opacity = this.opacityTween.lerp(this.age/this.deathAge)
    }
     viewer.dispatchEvent('content_changed');   
    
  }

}

export default Particle